import React from 'react';
import styles from './RegionPopup.scss';
import { connect, useDispatch } from 'react-redux';
import { setPopUp } from 'actions/environment';
import { withTranslation } from 'react-i18next';
import iconCheckMark from 'assets/images/check-mark.svg';
import { updateProfileRegion } from 'actions/profile';
import { allNews, nedvexNews, favoritesNews } from 'actions/news';
import { gaEvent, trackGA } from 'services/ga';

const getRegionList = (cities, profile, handleSelectRegionClick) =>
  cities.map((city) => {
    const { country } = city;

    return (
      <div
        key={city.id}
        className={styles.RegionItem}
        onClick={() => handleSelectRegionClick(city, profile)}
      >
        <span>{`${country.name}, ${city.name}`}</span>
        {String(city.id) === String(profile.cityId) && (
          <img className={styles.CheckMark} src={iconCheckMark} />
        )}
      </div>
    );
  });

const RegionPopup = ({ t, cities, profile, updateProfileRegion, setPopUp }) => {
  const dispatch = useDispatch();

  const handleSelectRegionClick = async (city, profile) => {
    if (city.id !== profile.cityId) {
      trackGA(
        gaEvent.locationDialogButtonsClick({
          eventContent: [city.country.name, city.name],
          user_id: profile.id,
        })
      );

      try {
        await updateProfileRegion({ ...profile, cityId: city.id });
        await dispatch(allNews({ limit: 20, offset: 0 }));
        await dispatch(nedvexNews({ limit: 20, offset: 0 }));
        await dispatch(favoritesNews({ limit: 20, offset: 0 }));
      } catch (error) {
        console.error(error);
      }
    }
    setPopUp();
  };

  return (
    <div className={styles.PopUpOuter}>
      <div className={styles.PopUpInner}>
        <div className={styles.PopupContent}>
          <div className={styles.PopupTitle}>{t('components.header.regionPopup.title')}</div>
          <div className={styles.PopupBody}>
            <div className={styles.RegionList}>
              {getRegionList(cities, profile, handleSelectRegionClick)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(
  (state) => ({
    userUid: state.profile.hash,
  }),
  { setPopUp, updateProfileRegion }
)(withTranslation()(RegionPopup));



// WEBPACK FOOTER //
// ./src/components/Header/Region/RegionPopup/RegionPopup.js